module.exports = __webpack_public_path__ + "img/MEDIA051.8ca0010a.jpg";